module.exports = __webpack_public_path__ + "static/media/stijn-bessem-meta-image.875de521.jpg";